import type { GraphDateType } from './dataKiGraph';
import type { GraphData } from './schemas';

export const GRAPH_FIELD_TYPES = [
  'daisu',
  'kyakuSu',
  'kadoRitu',
  'sijiRitu',
  'senyuRitu',
] as const;

export type GraphFieldType = (typeof GRAPH_FIELD_TYPES)[number];

const MKS_GRAPH_FIELD_TYPE_VALUE_SET = new Set<string>(GRAPH_FIELD_TYPES);

/**
 * 商圏推移グラフの項目コードが API 定義の列挙に含まれるか判定する。
 */
export function isMksGraphFieldType(value: string): value is GraphFieldType {
  return MKS_GRAPH_FIELD_TYPE_VALUE_SET.has(value);
}

export type DataKiMksTransitiveGraphData = {
  data: GraphData;
  setting: {
    field: GraphFieldType;
    startDate: string;
    endDate: string;
    dateType: GraphDateType;
    halls: string[];
    kiList: string[];
    shuList: string[];
    shuGroupIds: string[];
    excludeToday: boolean;
  };
};
